// ✅ File: src/layouts/DashboardLayout.js
import Navbar from "../components/Navbar";

const DashboardLayout = ({ children }) => {
  return (
    <>
      {/* ✅ Keep Navbar ONLY for Dashboard pages */}
      <Navbar />

      {/* ✅ Dashboard Content */}
      {children}
    </>
  );
};

export default DashboardLayout;